import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { RoutingService, TranslatePipe } from '@spartacus/core';
import { Subscription } from 'rxjs';

import { KnBrProductSelectService } from '../../../services/kn-br-product-select.service';
import { KnBrProductSalesOrgService, SALESORG } from 'src/app/services/kn-br-product-sales-org.service';
import { DomSanitizer } from '@angular/platform-browser';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { Router } from '@angular/router';
import { NgClass, LowerCasePipe } from '@angular/common';
import { MediaComponent, ItemCounterComponent } from '@spartacus/storefront';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KnBrAddToCartComponent } from '../../kn-br-add-to-cart/kn-br-add-to-cart.component';
import { KnBrAddToCartAlertPopupComponent } from '../../kn-br-add-to-cart/kn-br-add-to-cart-alert-popup.component';

@Component({
  selector: 'kn-br-product-grid-item',
  templateUrl: './kn-br-product-grid-item.component.html',
  styleUrls: ['./kn-br-product-grid-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, MediaComponent, LowerCasePipe, TranslatePipe, KnBrAddToCartComponent, ItemCounterComponent]
})
export class KnBrProductGridItemComponent implements OnDestroy, OnChanges {
  @Input() product: any;
  @Input() editable: boolean;
  salesOrg: SALESORG = {};
  selectedProductsCodes: string[];
  subscription: Subscription;
  quantity = 1;
  private readonly maxQuantity = 25;
  private hasShownMaxQuantityWarning = false;

  constructor(
    protected productSelectService: KnBrProductSelectService,
    protected routingService: RoutingService,
    protected knBrProductSalesOrgService: KnBrProductSalesOrgService,
    protected router: Router,
    private _sanitizer: DomSanitizer,
    private knBrCommonService: KnBrCommonService,
    private modalService: NgbModal,
    protected cd: ChangeDetectorRef,
  ) {
    this.subscription = this.productSelectService.loadSelectedProducts$().subscribe((selectedProductsCodes) => {
      this.selectedProductsCodes = selectedProductsCodes;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getSalesOrg(this.product.salesOrg);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getSalesOrg(salesOrg: string) {
    const _salesOrg = this.knBrProductSalesOrgService.getSalesOrgDetails(salesOrg);
    if (_salesOrg) {
      this.salesOrg = _salesOrg;
    }
  }

  getSVGImage(image) {
    return image ? this._sanitizer.bypassSecurityTrustHtml(`${image}`) : '';
  }

  // `applyQuantity` removed — inline normalization where needed.

  incrementQuantity(): void {
    this.quantity = this.quantity + 1;
  }

  decrementQuantity(): void {
    if (this.quantity > 1) {
      this.quantity = this.quantity - 1;
    }
  }

  onQuantityChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const rawVal = input.value;
    const raw = Number(rawVal);
    const normalized = Math.max(Number.isFinite(raw) ? raw : 1, 1);
    this.quantity = normalized;
    input.value = String(normalized);
    this.cd.markForCheck();
  }

  isChecked(code: string): boolean {
    if (this.selectedProductsCodes) {
      return this.selectedProductsCodes.indexOf(code) > -1;
    }
    return false;
  }
  changeCheckBox(event) {
    event.stopPropagation();
    const selectedProductCodes = event.currentTarget.checked ? this.addProductCode() : this.removeProductCode();
    this.productSelectService.setSelectedProducts(selectedProductCodes);
  }


  goToDetail(event) {
    if (event.target.closest('.product-actions')) {
      return;
    }
    if (event.target && event.target.classList && !event.target.classList.contains('custom-control-input')) {
      event.stopPropagation();
      event.preventDefault();
      const urlValue = this.routingService.getUrl({
        cxRoute: 'product',
        params: this.product
      });
      this.knBrCommonService.setSpinner(true);
      this.router.navigateByUrl(urlValue);
    }
  }




  addProductCode() {
    if (this.selectedProductsCodes && this.selectedProductsCodes.length) {
      this.selectedProductsCodes.push(this.product.code);
    } else {
      this.selectedProductsCodes = [this.product.code];
    }
    return this.selectedProductsCodes;
  }
  removeProductCode() {
    this.selectedProductsCodes.splice(this.selectedProductsCodes.indexOf(this.product.code), 1);
    return this.selectedProductsCodes;
  }

  getAddToCart(product) {
    return product && product.addToCartEnabled?.toLowerCase() === 'yes' ? true : false;
  }
}
